import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  to: '',
  from: '',
  amount: '',
  createdBy: '',
  paymentMethod: '',
  expenseDateEnd: '',
  spendingCategory: '',
  expenseDateStart: '',
}

const spendingFilterSlice = createSlice({
  name: 'spendingFilter',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state[action.payload.property] = action.payload.value
    },
  },
})

export const { setFilter } = spendingFilterSlice.actions
export default spendingFilterSlice.reducer
